import { configureStore } from "@reduxjs/toolkit";

import { appConfigMiddleware } from "../middleware/AppConfigs";
import createRootReducer from "./index";

function configureAppStore(){
  return configureStore({
    reducer: createRootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(appConfigMiddleware),
  });
}
export default configureAppStore;
